import axios from 'axios'
import store from '@/store'
import { getTokenData } from '@/services/token.service'
import i18nService from '../services/i18n.service'
import router from "@/router";

let isRefreshing = false
let subscribers = []
const subscribeTokenRefresh = cb => subscribers.push(cb)
const onRefreshed = token => subscribers.map(cb => cb(token))

const axiosReportsInstance = axios.create({
  baseURL: `${process.env.VUE_APP_REPORTS_API_ORIGIN}/api/v1`,
})

axiosReportsInstance.interceptors.request.use(
  config => {
    config.headers = {
      Accept: 'application/json',
      'Accept-Language': config.loc || i18nService.getActiveLanguage(),
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      ...(config?.params?.isFilter ? {} : {'additional-groups': 'detailed'}),
      ...config.headers,
    }
    delete config?.params?.isFilter
    const tokenData = getTokenData()
    if (tokenData && config.url !== 'token/refresh') {
      const { token } = JSON.parse(tokenData)
      config.headers.Authorization = 'Bearer ' + token
    }
    const globalFilter = window.localStorage.getItem('admin_global_filter')
    if (globalFilter !== null && +globalFilter !== 0){
      config.headers['group-filter'] = +globalFilter
    }
    return config
  },
  error => {
    return Promise.reject(error)
  },
)

axiosReportsInstance.interceptors.response.use(
  response => {
    return response
  },
  async function (err) {
    const config = err.config
    const status = err.response ? err.response.status : null
    const originalRequest = config
    if (status === 401 && !['token/refresh', 'token/logout'].includes(config.url)) {
      if (!isRefreshing) {
        isRefreshing = true
        store
          .dispatch('AuthModule/onRefreshToken')
          .then(data => {
            isRefreshing = false
            onRefreshed(data.token)
            subscribers = []
          })
          .catch(() => {
            isRefreshing = false
            subscribers = []
            store.dispatch('AuthModule/onLogout')
          })
      }
      return new Promise(resolve => {
        subscribeTokenRefresh(token => {
          originalRequest.headers.Authorization = `Bearer ${token}`
          resolve(axiosReportsInstance(originalRequest))
        })
      })
    }
    if (status === 401 && ['token/refresh', 'token/logout'].includes(config.url)){
      store.commit('AuthModule/purgeAuth')
      await router.replace('/login')
    }
    if(status === 403 && !config.skip403Redirect){
      router.push({ name: 'PageError403' })
    }
    return Promise.reject(err)
  },
)

export default axiosReportsInstance
